/**
 * Generator 11: Navigation — emit per-schema extract under admin/data/navigation/
 */

import type { GeneratedFile, GeneratorOptions, Schema } from '@core-engine/schema/types.js'
import { createGeneratedFile } from '@core-engine/utils/generated-files.js'
import { toCamelCase } from '@core-engine/utils/string.js'

const NO_NAV_SCHEMAS = new Set(['settings'])

export interface NavigationGeneratorResult {
  files: GeneratedFile[]
}

function buildNavigationItem(schema: Schema, adminRoutePath: string): string {
  const lines = [
    `    label: '${schema.label}'`,
    `    href: '${adminRoutePath}/${schema.name}'`,
    `    icon: ${schema.icon}`
  ]

  if (schema.navGroup) {
    lines.push(`    group: '${schema.navGroup.label}'`)
    if (schema.navGroup.icon) {
      lines.push(`    groupIcon: ${schema.navGroup.icon}`)
    }
    if (schema.navGroup.position != null) {
      lines.push(`    groupPosition: ${schema.navGroup.position}`)
    }
  }

  if (schema.navPosition != null) {
    lines.push(`    position: ${schema.navPosition}`)
  }

  return `  {\n${lines.join(',\n')}\n  }`
}

export function updateNavigation(
  schema: Schema,
  navigationDir: string,
  options: GeneratorOptions = {}
): NavigationGeneratorResult {
  if (NO_NAV_SCHEMAS.has(schema.name)) {
    return { files: [] }
  }

  const adminRoutePath = options.adminRoutePath ?? '/admin'

  const imports = new Set<string>([schema.icon])
  if (schema.navGroup?.icon) {
    imports.add(schema.navGroup.icon)
  }

  const content = `import type { AdminNavigationItem } from '@admin/types/navigation'
import { ${Array.from(imports).sort().join(', ')} } from 'lucide-react'

export const ${toCamelCase(schema.name)}Nav: AdminNavigationItem[] = [
${buildNavigationItem(schema, adminRoutePath)}
]
`

  return {
    files: [createGeneratedFile(`${navigationDir}/${schema.name}.ts`, content)]
  }
}
